import React from 'react';
import {Box} from '@mui/material';
import Label from 'shared/components/label';
import FileUploadForm from 'src/components/FileUploadForm';
import FormikTextField from 'src/components/FormikTextField';

const DisplayUploadedFileUrl = (props: {uploadedFile: {publicUrl: string}}): React.ReactElement => (
  <Box mt={6}>
    <div className="alert alert-info" role="alert">
      <strong>Public URL: </strong>
      <a href={props.uploadedFile.publicUrl} rel="noopener noreferrer" target="_blank">
        {props.uploadedFile.publicUrl}
      </a>
    </div>
  </Box>
);

const PublicResourceUploader = (): React.ReactElement => (
  <FileUploadForm
    title="Upload public resource"
    fileDescription="Upload any resource for which you want a public url."
    UploadedFileElement={DisplayUploadedFileUrl}
    uploadType="public_resource"
    resetAfterSubmit={false}
  >
    <Box py={1}>
      Upload a file to s3 and get a public Raise Me-branded URL for it. Note all uploaded files will
      be publicly accessible.
    </Box>
    <Box py={2}>
      <Label>
        (Optional): Set path to upload file to
        <FormikTextField placeholder="path/to/file" name="path" />
      </Label>
    </Box>
  </FileUploadForm>
);

export default PublicResourceUploader;
